import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BasketType } from "../BasketService";
import { NaviButtons } from "../components/NaviButtons";

const basketTypes = [BasketType.Micro, BasketType.Small, BasketType.Compact];

export const StepBasketSelection = ({
	returnUrl,
	onNext
}: {
	returnUrl: string;
	onNext: (basket: BasketType) => void;
}) => {
	const { t } = useTranslation();
	const [basket, setBasket] = useState<BasketType | undefined>(undefined);

	return (
		<>
			<section id="package-selection">
				<div className="row space-t">
					<div className="col-md-12">
						<h3>
							{t("packageSelectionTitle")}
						</h3>
						<p>{t("packageSelectionContent")}</p>
					</div>
					<div className="col-md-12">
						<div className="row package-option-row">
							{basketTypes.map((b) => (
								<div className="col-md-4 col-sm-12 col-xs-12">
									<div className={`package-option ${basket === b ? "active" : "inactive"}`} onClick={() => setBasket(b)}>
										<div className="selector-elem">&#10003;</div>
										<h3>{t(`type${b}`)}</h3>
										<div className="price">
											<h4>{t(`price${b}`)} €</h4>
											<span> / {t("month")}</span>
										</div>
										<div className="package-description">
											<div className="description">
												<h5>{t("maxUsageCountTitle")}</h5>
												<div>{t(`maxUsageCount${b}`)}</div>
												<h5>{t("subscriptionPeriodTitle")}</h5>
												<div>{t("subscriptionPeriodContent")}</div>
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className="col-md-12">
						<p>{t("packageSelectionTerms1")}</p>
						<p>{t("packageSelectionTerms2")}</p>
						<p>{t("packageSelectionTerms3")}</p>
					</div>
				</div>
			</section>
			<NaviButtons
				cancelVisible
				onCancel={() => (window.location.href = returnUrl)}
				backVisible={false}
				nextDisabled={!basket}
				onNext={() => onNext(basket ?? BasketType.Small)}
			/>
		</>
	);
};
